import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Tag = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M4.15706 15.3094L8.69447 19.8513C10.5575 21.7162 13.5825 21.7162 15.4555 19.8513L19.8527 15.4498C21.7158 13.5848 21.7158 10.5569 19.8527 8.68196L15.3053 4.15005C14.3537 3.19754 13.0416 2.6862 11.6994 2.75638L6.6912 2.99702C4.68792 3.08725 3.09532 4.68144 2.99516 6.67669L2.75476 11.6899C2.69467 13.0434 3.2055 14.3569 4.15706 15.3094Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.49416 9.99564C9.32394 9.99564 9.99661 9.3223 9.99661 8.49169C9.99661 7.66107 9.32394 6.98773 8.49416 6.98773C7.66437 6.98773 6.9917 7.66107 6.9917 8.49169C6.9917 9.3223 7.66437 9.99564 8.49416 9.99564Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.69447 19.8513L4.15706 15.3094C3.2055 14.3569 2.69467 13.0434 2.75476 11.6899L2.99516 6.67669C3.09532 4.68144 4.68792 3.08725 6.6912 2.99702L11.6994 2.75638C13.0416 2.6862 14.3537 3.19754 15.3053 4.15005L19.8527 8.68196C21.7158 10.5569 21.7158 13.5848 19.8527 15.4498L15.4555 19.8513C13.5825 21.7162 10.5575 21.7162 8.69447 19.8513ZM9.99671 8.49166C9.99671 9.32227 9.32404 9.99561 8.49425 9.99561C7.66447 9.99561 6.9918 9.32227 6.9918 8.49166C6.9918 7.66105 7.66447 6.9877 8.49425 6.9877C9.32404 6.9877 9.99671 7.66105 9.99671 8.49166Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
